



import React from 'react';

export default function Participated({
  showAlreadyUsedPopup,
  onClose,
  previousWinData,
  mobileNumber,
  formatMobile
}) {
  if (!showAlreadyUsedPopup) return null;

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 99999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.7)',
        padding: '15px'
      }}
    >
      <div
        style={{
          backgroundColor: '#FDFBF4',
          borderRadius: '24px',
          width: '100%',
          maxWidth: '380px',
          boxShadow: '0 20px 25px -5px rgba(0,0,0,0.5)',
          fontFamily: 'sans-serif',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <div
          style={{
            background: 'linear-gradient(to right, #B5852A 0%, #4A300F 50%, #9A6A1A 100%)',
            padding: '20px 10px 25px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px'
          }}
        >
          <div
            style={{
              color: 'white',
              fontSize: '17px',
              fontWeight: 'bold',
              fontFamily: 'Georgia, serif',
              paddingTop: '5px'
            }}
          >
            LOGO
          </div>
        </div>

        <div
          style={{
            padding: '0 20px 20px',
            textAlign: 'center',
            position: 'relative'
          }}
        >
          <h2
            style={{
              margin: '25px 0 5px',
              fontSize: '22px',
              fontWeight: 'bold',
              color: '#000',
              fontFamily: 'Georgia, serif'
            }}
          >
             Already Participated!
          </h2>

          <p
            style={{
              color: '#444',
              fontSize: '12px',
              marginBottom: '20px',
              lineHeight: '1.4'
            }}
          >
            This mobile number has already spin the wheel.<br />
            you can spin again after 7 days
          </p>

          <div
            style={{
              backgroundColor: '#FDFBF4',
              borderRadius: '10px',
              padding: '12px 15px',
              border: '1px solid #D4AF37',
              marginBottom: '15px',
              textAlign: 'left'
            }}
          >
            <div
              style={{
                fontSize: '10px',
                fontWeight: 'bold',
                color: '#666',
                marginBottom: '12px',
                letterSpacing: '1px'
              }}
            >
              YOUR EXISTING VOUCHER
            </div>

            {[
              {
                icon: '📱',
                label: 'Mobile:',
                value: previousWinData?.mobile || formatMobile(mobileNumber)
              },
              {
                icon: '🎁',
                label: 'Prize:',
                value: previousWinData?.prize
                  ? `${previousWinData.prize} ${previousWinData.subCategory ? `- ${previousWinData.subCategory}` : ''}`
                  : 'Discount Voucher'
              },
                        {
                icon: '🕒',
                label: 'Status:',
                value: (
                  <span style={{ color: '#D4AF37', fontWeight: 'bold' }}>
                    ● {previousWinData?.status || 'Pending'}
                  </span>
                )
              },
              {
                icon: '📅',
                label: 'Valid until:',
                value: previousWinData?.validUntil || 'N/A'
              }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: '8px'
                }}
              >
                <div
                  style={{
                    marginRight: '12px',
                    fontSize: '14px',
                    flexShrink: 0,
                    color: '#D4AF37',
                    width: '16px',
                    textAlign: 'center'
                  }}
                >
                  {item.icon}
                </div>

                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: index !== 4 ? '1px solid #E5D3A1' : 'none',
                    paddingBottom: '6px'
                  }}
                >
                  <span
                    style={{
                      color: '#555',
                      fontSize: '12px',
                      minWidth: '60px'
                    }}
                  >
                    {item.label}
                  </span>

                  <span
                    style={{
                      fontWeight: '600',
                      fontSize: '12px',
                      color: '#000',
                      textAlign: 'right'
                    }}
                  >
                    {item.value || 'N/A'}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div
            style={{
              backgroundColor: '#E8F5E9',
              padding: '12px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '15px',
              border: '1px solid #A5D6A7'
            }}
          >
            <div
              style={{
                backgroundColor: '#439A46',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.571-.012c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
              </svg>
            </div>

            <div
              style={{
                width: '1px',
                height: '26px',
                backgroundColor: '#81C784'
              }}
            />

            <div
              style={{
                textAlign: 'left',
                flex: 1
              }}
            >
              <div
                style={{
                  fontSize: '10.5px',
                  fontWeight: 'bold',
                  color: '#000',
                  marginBottom: '2px'
                }}
              >
                Your voucher was sent to your WhatsApp.
              </div>

              <div
                style={{
                  fontSize: '10.5px',
                  color: '#444'
                }}
              >
                Check your messages!
              </div>
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '8px',
              border: 'none',
              background: 'linear-gradient(to right, #B5852A 0%, #482E0F 50%, #A47A30 100%)',
              color: 'white',
              fontWeight: 'bold',
              cursor: 'pointer',
              fontSize: '16px',
              fontFamily: 'Georgia, serif',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            Back <span style={{ fontSize: '18px', fontWeight: 'normal' }}></span>
          </button>
        </div>
      </div>
    </div>
  );
}